export const logParams = [
  'xeswx_sourceid',
  'xeswx_adsiteid',
  'xeswx_siteid',
  'xeswx_sessid'
]

export const queryComputed = (to, from) => {
  logParams.forEach(item => {
    if (item in from.query) {
      to.query[item] = from.query[item]
    }
  })
  to.query['query_computed'] = '1'
  const { query, params, name } = to
  return { query, params, name }
}



// WEBPACK FOOTER //
// ./src/defines/logParams.js